export default "__VITE_ASSET__B_0ek5ee__"